<template>
    <AdminLayout>
        <section class="flex items-start px-14 space-x-9">
            <div class="w-full">
                <div class="mt-12 border rounded-lg py-7 px-8">
                    <div class="flex justify-between mb-5">
                        <p class="font-semibold text-xl text-neutral-800">Add Payroll</p>
                    </div>
                    <div v-if="loading" class="grid grid-cols-2 gap-x-6 gap-y-4 animate-pulse">
                        <div class="px-2 py-2" v-for="index in 2" :key="index">
                            <span class="w-full rounded h-8 bg-neutral-200 block"></span>
                        </div>
                        <div class="px-2 py-2 col-span-2 pt-5">
                            <span class="w-full rounded h-8 bg-neutral-200 block"></span>
                        </div>
                        <div class="px-2 py-2" v-for="index in 4" :key="index">
                            <span class="w-full rounded h-8 bg-neutral-200 block"></span>
                        </div>
                        <div class="px-2 py-2 col-span-2 pt-5" v-for="index in 2" :key="index">
                            <span class="w-full rounded h-8 bg-neutral-200 block"></span>
                        </div>
                        <div class="grid grid-cols-3 col-span-2 gap-2">
                            <div class="px-2 py-2" v-for="index in 9" :key="index">
                                <span class="w-full rounded h-8 bg-neutral-200 block"></span>
                            </div>
                        </div>
                        
                    </div>
                    <div  v-else class=" ">
                        <form @submit.prevent="submitPayroll">
                            
                            <div class="grid grid-cols-2 gap-x-6 gap-y-4">
                                <div>
                                    <label class="text-sm font-medium text-[#3c3c3c] block mb-1">Basic:</label>
                                    <input
                                        class="border-none px-4 py-3 block text-sm text-neutral-800 font-medium rounded-md bg-[#f5f5f5] w-full"
                                        type="number" placeholder="Add %" v-model="payroll.basic">
                                </div>
                                <div>
                                    <label class="text-sm font-medium text-[#3c3c3c] block mb-1">HRA:</label>
                                    <input
                                        class="border-none px-4 py-3 block text-sm text-neutral-800 font-medium rounded-md bg-[#f5f5f5] w-full"
                                        type="number" placeholder="Add %" v-model="payroll.hra">
                                </div>
                                <div class="flex items-center col-span-2 pt-5">
                                    <h3 class="text-lg font-medium text-[#3c3c3c] block mr-2">Allowance:</h3>
                                    <div class="border-t border-neutral-200 grow mr-3"></div>
                                    <button type="button"
                                        class="bg-blue-500 text-white text-xs px-3 py-2 rounded-md capitalize"
                                        @click="addField">
                                        + add
                                    </button>
                                </div>

                                <div v-for="(field, index) in payroll.allowances" :key="index"
                                    class="col-span-2 flex gap-2 items-center">
                                    <input v-model="field.name"
                                        class="border-none px-4 py-3 block text-sm text-neutral-800 font-medium rounded-md bg-[#f5f5f5] w-full grow"
                                        type="text" placeholder="Name" @input="sanitizeNameInput(index)">
                                    <input v-model="field.percentage"
                                        class="border-none px-4 py-3 block text-sm text-neutral-800 font-medium rounded-md bg-[#f5f5f5] w-full grow"
                                        type="number" placeholder="Percentage">
                                    <button type="button" @click="removeField(index)"
                                        class="w-7 h-7 shrink-0 bg-red-100 text-red-500 flex items-center justify-center rounded-md">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21"
                                            viewBox="0 0 21 21">
                                            <path fill="none" stroke="currentColor" stroke-linecap="round"
                                                stroke-linejoin="round" d="m15.5 15.5l-10-10zm0-10l-10 10"
                                                stroke-width="1" />
                                        </svg>
                                    </button>
                                </div>

                                <!-- PF Section 1 -->
                                <div class="flex items-center mt-5">
                                    <h3 class="text-lg font-medium text-[#3c3c3c] block mr-2">PF:</h3>
                                    <div class="flex items-center mr-2">
                                        <input type="radio" id="pf-yes-1" value="true" v-model="payroll.pf.enabled"
                                            class="mr-1">
                                        <label for="pf-yes-1" class="text-sm font-medium text-[#3c3c3c]">Yes</label>
                                    </div>
                                    <div class="flex items-center">
                                        <input type="radio" id="pf-no-1" value="false" v-model="payroll.pf.enabled"
                                            class="mr-1">
                                        <label for="pf-no-1" class="text-sm font-medium text-[#3c3c3c]">No</label>
                                    </div>
                                    <!-- <div v-if="payroll.pf.enabled === 'true'" class="w-full ml-3">
                                        <input class="border-none px-4 py-3 block text-sm text-neutral-800 font-medium rounded-md bg-[#f5f5f5] w-full" type="text" placeholder="Add PF %" v-model="payroll.pf.percentage">
                                    </div> -->
                                </div>

                                <!-- PF Section 2 -->
                                <div class="flex items-center mt-5">
                                    <h3 class="text-lg font-medium text-[#3c3c3c] block mr-2">ESI:</h3>
                                    <div class="flex items-center mr-2">
                                        <input type="radio" id="pf-yes-2" value="true" v-model="payroll.esi.enabled"
                                            class="mr-1">
                                        <label for="pf-yes-2" class="text-sm font-medium text-[#3c3c3c]">Yes</label>
                                    </div>
                                    <div class="flex items-center">
                                        <input type="radio" id="pf-no-2" value="false" v-model="payroll.esi.enabled"
                                            class="mr-1">
                                        <label for="pf-no-2" class="text-sm font-medium text-[#3c3c3c]">No</label>
                                    </div>
                                    <!-- <div v-if="payroll.esi.enabled === 'true'" class="w-full ml-3">
                                        <input class="border-none px-4 py-3 block text-sm text-neutral-800 font-medium rounded-md bg-[#f5f5f5] w-full" type="text" placeholder="Add ESI %" v-model="payroll.esi.percentage">
                                    </div> -->
                                </div>

                                <!-- Ptax Section Header with Add Button -->
                                <div class="flex items-center col-span-2 pt-6">
                                    <h3 class="text-lg font-medium text-[#3c3c3c] block mr-2">Ptax:</h3>
                                    <div class="border-t border-neutral-200 grow mx-3"></div>
                                    <button type="button"
                                        class="bg-blue-500 text-white text-xs px-3 py-2 rounded-md capitalize"
                                        @click="addPtaxField">
                                        + Add
                                    </button>
                                </div>

                                <!-- Ptax Table (Hidden by Default, Shown When Entries Exist) -->
                                <div v-if="payroll.ptax.length > 0" class="col-span-2">
                                    <div class="grid grid-cols-3 col-span-2 bg-slate-100/60 px-2 rounded-md">
                                        <div class="px-4 font-medium">From</div>
                                        <div class="px-4 font-medium">To</div>
                                        <div class="px-4 font-medium">Total Amount</div>
                                    </div>

                                    <div v-for="(ptax, index) in payroll.ptax" :key="index"
                                        class="grid grid-cols-3 gap-2 col-span-2 mt-2">
                                        <input v-model="ptax.from"
                                            class="border-none px-4 py-3 block text-sm text-neutral-800 font-medium rounded-md bg-[#f5f5f5] w-full"
                                            type="number" placeholder="20000">
                                        <input v-model="ptax.to"
                                            class="border-none px-4 py-3 block text-sm text-neutral-800 font-medium rounded-md bg-[#f5f5f5] w-full"
                                            type="number" placeholder="40000">
                                        <div class="flex items-center">
                                            <input v-model="ptax.amount"
                                                class="border-none px-4 py-3 block text-sm text-neutral-800 font-medium rounded-md bg-[#f5f5f5] w-full"
                                                type="number" placeholder="180">
                                            <button type="button" @click="removePtaxField(index)"
                                                class="w-7 h-7 shrink-0 bg-red-100 text-red-500 flex items-center justify-center rounded-md ml-2">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21"
                                                    viewBox="0 0 21 21">
                                                    <path fill="none" stroke="currentColor" stroke-linecap="round"
                                                        stroke-linejoin="round" d="m15.5 15.5l-10-10zm0-10l-10 10"
                                                        stroke-width="1" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="mt-10 text-right">
                                <button type="submit" class="btn-primary-light flex items-center"> Submit </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <!-- <RightSideBar /> -->
        </section>
    </AdminLayout>
</template>

<script>
import axios from 'axios';
import AdminLayout from '../AdminDashboard/AdminLayout.vue';
// import RightSideBar from '../../components/RightSideBar.vue';
import { BASE_URL } from "../../config";
import { createToast } from 'mosha-vue-toastify';
export default {
    name: 'CountryList',
    components: {
        AdminLayout,
        // RightSideBar,
    },
    data() {
        return {
            fields: [],
            ptaxFields: [], // Array to hold dynamic Ptax fields
            pfSelection1: '',
            pfSelection2: '',
            loading: true, // <-- Add this line
            payroll: {
                basic: '',
                hra: '',
                allowances: [],
                pf: { enabled: "false" },
                esi: { enabled: "false" },
                ptax: [],
                company_id: localStorage.getItem('company_id')
            }
        };
    },
    created() {
        this.getPayrollData();
    },
    methods: {
        sanitizeNameInput(index) {
        const name = this.payroll.allowances[index].name;
        // Allow only letters and spaces
        this.payroll.allowances[index].name = name.replace(/[^a-zA-Z\s]/g, '');
        },

        tostMessage(type, message) {
            createToast({ description: message }, {
                type,
                timeout: 2500,
                position: 'bottom-right',
                showIcon: true
            });
        },
        addField() {
            this.payroll.allowances.push({ name: '', percentage: '' });
        },
        removeField(index) {
            this.payroll.allowances.splice(index, 1);
        },
        addPtaxField() {
            this.payroll.ptax.push({ from: '', to: '', amount: '' });
        },
        removePtaxField(index) {
            this.payroll.ptax.splice(index, 1);
        },

        async submitPayroll() {
                // Step 1: Validate the sum of Basic, HRA, and Allowances
                const totalPercentage = parseFloat(this.payroll.basic) + parseFloat(this.payroll.hra) + 
                    this.payroll.allowances.reduce((sum, allowance) => sum + parseFloat(allowance.percentage || 0), 0);

                if (totalPercentage !== 100) {
                    // Step 2: If total is not 100, show a toast message and prevent form submission
                    createToast(`The total of Basic, HRA, and Allowances must be exactly 100%. Current total is ${totalPercentage}%.`, {
                        type: 'danger',
                    });
                    return; // Stop form submission
                }
            try {
                let response;
                if (this.isEditing && this.payroll.id) {
                    // Update payroll if already exists
                    response = await axios.put(BASE_URL + `/update-payroll/${this.payroll.id}`, this.payroll);
                    //alert('Payroll updated successfully!');
                    createToast('Payroll updated successfully!', { type: 'success' });
                } else {
                    // Create a new payroll entry
                    response = await axios.post(BASE_URL + '/add-payroll', this.payroll);
                    //alert('Payroll submitted successfully!');
                    createToast('Payroll submitted successfully!', { type: 'success' });
                }
                console.log(response.data);
            } catch (error) {
                if (error.response && error.response.data) {
                    const serverError = error.response.data;

                    // If it's a Laravel validation error
                    if (serverError.errors) {
                        const allErrors = Object.values(serverError.errors).flat();
                        //alert(allErrors.join('\n')); // Show all validation messages
                        createToast(allErrors.join('\n'), { type: 'danger' });
                    } else if (serverError.message) {
                        //alert(serverError.message); // Show general message
                        createToast(serverError.message, { type: 'danger' });
                    } else {
                        //alert('An unexpected error occurred.');
                        createToast('An unexpected error occurred', { type: 'danger' });
                    }

                    console.error('Validation error:', serverError);
                } else {
                    console.error('Error submitting payroll:', error);
                    //alert('Error submitting payroll!');
                    createToast('Error submitting payroll!', { type: 'danger' });
                }
            }

        },

        async getPayrollData() {
            this.loading = true; // Start loading
            try {
                const formData = {
                    "company_id": localStorage.getItem('company_id')
                };
                const response = await axios.post(BASE_URL + '/get-payroll-data', formData);
                console.log('payroll data', response.data);//here is the response i have provided to you
                if (response.data && response.data.payrollData.length > 0) {
                    const payrollRecord = response.data.payrollData[0];

                    // Assign values, parsing JSON where needed
                    this.payroll = {
                        id: payrollRecord.id,
                        company_id: payrollRecord.company_id,
                        basic: payrollRecord.basic,
                        hra: payrollRecord.hra,
                        allowances: JSON.parse(payrollRecord.allowances || '[]'),
                        esi: JSON.parse(payrollRecord.esi || '{"enabled": false }'),
                        pf: JSON.parse(payrollRecord.pf || '{"enabled": false }'),
                        ptax: JSON.parse(payrollRecord.ptax || '[]')
                    };

                    this.isEditing = true;
                } else {
                    this.isEditing = false;
                }
            } catch (error) {
                console.error('Error fetching payroll data:', error);
                //alert('Error fetching payroll data!');
                createToast('Error fetching payroll data!', { type: 'danger' });
            } finally {
                 this.loading = false; // End loading
            }
        }
    }
}
</script>

<style scoped>
/* Remove default input focus */
input:focus {
    outline: none;
}
</style>
